import React from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import { ModalManager, ThemeProvider } from '@3plearning/react-components';

import ClassGroupFilters from '@components/class-group-filters';
import { Standards } from '@components/standards';
import { dismissModal } from '@containers/modal-manager/modal-manager-actions';
import StudentList from '@components/student-list';
import Toast from '@components/toast';
import CourseFilters from '@components/course-filters';
import SearchableDropDownList from '@components/searchable-dropdownlist';
import Footer from '@components/footer';
import GridActions from '@components/grid-actions';
import usePollingV2 from "../../helpers/hooks/use-polling-v2";

import ErrorBoundary from '../error-boundary';
import css from './upf-assign.scss';

const UpfAssign = ({ i18n }) => {
  const dispatch = useDispatch();

  usePollingV2();

  const toastProps = useSelector(state => state.toastReducer, shallowEqual);
  const previewModal = useSelector(state => state.modalContainerReducer, shallowEqual);

  const previewModalTheme = {
    overrides: {
      modal: {
        width: '100%',
        maxWidth: '900px'
      }
    }
  };

  return (
    <React.Fragment>
      <div className={css.filterBar}>
        <div className={css.courseFilter}>
          <ErrorBoundary>
            <CourseFilters />
          </ErrorBoundary>
        </div>
        <div className={css.search}>
          <SearchableDropDownList id="SearchableDropDownList" i18n={i18n} />
        </div>
        <GridActions i18n={i18n} />
      </div>
      <div className={css.component}>
        <div className={css.leftSection}>
          <ErrorBoundary>
            <ClassGroupFilters />
          </ErrorBoundary>
          <ErrorBoundary>
            <StudentList i18n={i18n} />
          </ErrorBoundary>
        </div>
        <div
          className={css.rightSection}
          onScroll={e => {
            if (document.getElementById('studentList')) {
              document.getElementById('studentList').scrollTop = e.target.scrollTop;
            }
          }}
        >
          <ErrorBoundary>
            <Standards i18n={i18n} />
          </ErrorBoundary>
        </div>
      </div>
      <div className={css.footer}>
        <ErrorBoundary>
          <Toast {...toastProps} />
        </ErrorBoundary>
      </div>
      <Footer />
      <ThemeProvider theme={previewModalTheme}>
        <ErrorBoundary>
          <ModalManager
            modals={previewModal}
            onClose={() => {
              dispatch(dismissModal());
            }}
          />
        </ErrorBoundary>
      </ThemeProvider>
    </React.Fragment>
  );
};

UpfAssign.propTypes = {
  filteredStudents: PropTypes.array,
  selectedStudentIds: PropTypes.array,
  selectedPSRs: PropTypes.array,
  selectedCells: PropTypes.array,
  i18n: PropTypes.object,
  playLists: PropTypes.array,
  pausePolling: PropTypes.bool,
  selectedPlaylistId: PropTypes.bool,
  classrooms: PropTypes.array
};

UpfAssign.whyDidYouRender = false;

export default UpfAssign;



// WEBPACK FOOTER //
// ./containers/upf-assign/upf-assign.js